module.exports = __webpack_public_path__ + "img/3.c56f0a64.png";